import '@talentmesh/table/styles.css';
import { type MRT_TableInstance, ShadcnReactTable } from '@talentmesh/table';
import CandidatesListPaper from '../../../components/CandidatesListPaper';
import AiSearchListNav from '../AiSearchListNav';
import ShortlistedListToolbar from './ShortlistedListToolbar';
import { useShortlistedListContext } from './utils/ShortlistedListContext';
import { useShortlistedTableContext } from './utils/ShortlistedTableContext';
import CandidatesTableContainer from '@/Pages/Candidates/components/CandidatesTableContainer';

const paginationSizeOptions = [20, 50, 75];

const ShortlistedList = () => {
    const table = useShortlistedTableContext();
    const shortlistedList = useShortlistedListContext();

    return (
        <CandidatesListPaper data-cy="shortlistedList">
            <ShortlistedListToolbar />
            <CandidatesTableContainer>
                <ShadcnReactTable table={table} />
            </CandidatesTableContainer>
            <AiSearchListNav
                {...shortlistedList}
                table={table as MRT_TableInstance<any>}
                paginationSizeOptions={paginationSizeOptions}
            />
        </CandidatesListPaper>
    );
};

export default ShortlistedList;
